import search from '@/Scripts/search.js';
import { toCurrencyFormat } from '@Core/Composables/helpers';

window.globalSearch = search;
window.headerSearch = search;
window.toCurrencyFormat = toCurrencyFormat;
